import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Layout } from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Accounts from './pages/Accounts';
import AccountDetail from './pages/AccountDetail';
import Contacts from './pages/Contacts';
import ContactDetail from './pages/ContactDetail';
import Opportunities from './pages/Opportunities';
import OpportunityDetail from './pages/OpportunityDetail';
import Contracts from './pages/Contracts';
import ContractDetail from './pages/ContractDetail';
import Tasks from './pages/Tasks';
import Activities from './pages/Activities';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Staffing from './pages/Staffing';
import './styles.css';

function ProtectedRoute({ children, hideFromViewer }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',color:'var(--gray-400)',fontSize:14,flexDirection:'column',gap:12 }}>
      <div style={{ fontSize:32 }}>⚡</div>
      <div>Loading Pulse...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (hideFromViewer && user.role === 'viewer') return <Navigate to="/accounts" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<ProtectedRoute hideFromViewer><Dashboard /></ProtectedRoute>} />
      <Route path="/accounts" element={<ProtectedRoute><Accounts /></ProtectedRoute>} />
      <Route path="/accounts/:id" element={<ProtectedRoute><AccountDetail /></ProtectedRoute>} />
      <Route path="/contacts" element={<ProtectedRoute><Contacts /></ProtectedRoute>} />
      <Route path="/contacts/:id" element={<ProtectedRoute><ContactDetail /></ProtectedRoute>} />
      <Route path="/opportunities" element={<ProtectedRoute hideFromViewer><Opportunities /></ProtectedRoute>} />
      <Route path="/opportunities/:id" element={<ProtectedRoute hideFromViewer><OpportunityDetail /></ProtectedRoute>} />
      <Route path="/contracts" element={<ProtectedRoute hideFromViewer><Contracts /></ProtectedRoute>} />
      <Route path="/contracts/:id" element={<ProtectedRoute hideFromViewer><ContractDetail /></ProtectedRoute>} />
      <Route path="/tasks" element={<ProtectedRoute><Tasks /></ProtectedRoute>} />
      <Route path="/activities" element={<ProtectedRoute><Activities /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute hideFromViewer><Reports /></ProtectedRoute>} />
      <Route path="/staffing" element={<ProtectedRoute hideFromViewer><Staffing /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
